<template>
	<div full-height>
		<div class="display_wrapper" id="non-printable">

			<v-toolbar flat fixed>
			    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

			    <v-toolbar-title class="white--text">Stock Adjustment</v-toolbar-title>

			    <v-spacer></v-spacer>

			    <!-- <v-btn round-borders outline @click="fn_edit" v-if="displayData && displayData.status==1">edit</v-btn> -->
			    <v-btn icon @click="fn_edit" v-if="displayData && displayData.status==1">
			    	<v-icon>edit</v-icon>
			    </v-btn>

			    <v-btn icon @click="fn_getBottomMenu">
			      <v-icon>more_vert</v-icon>
			    </v-btn>

			</v-toolbar>

			<div full-height grey-back class="display hasToolbar hasBigFooterWithExtention">

				<v-alert :value="displayData && displayData.status==0" type="warning" transition="slide-y-transition">
					<span>This transaction has been cancelled!</span>
				</v-alert>

				<v-list nopadding>
				  	<v-list-tile>
			          	<v-list-tile-content>
			              <v-list-tile-title>Date</v-list-tile-title>
			            </v-list-tile-content>

			            <v-list-tile-action>{{displayData.transactionDate | moment("DD-MMM-YYYY")}}</v-list-tile-action>
				    </v-list-tile>
				</v-list>

				<!-- <v-divider></v-divider> -->

				
				<v-list three-line nopadding margin-top-ten>

					<div grey-back v-for="(item, index) in displayData.transactionProducts" :key="index">
						<v-list-tile class="right-subtitle-tile custom-action-tile white-background">
						    <v-list-tile-content>

						      <v-list-tile-title class="mb-1">{{item.productName}}</v-list-tile-title>
						      	<v-list-tile-sub-title class="mb-1">
						      		{{item.transactionProductMode ? 'Added' : 'Reduced'}}
						   		</v-list-tile-sub-title>

						   		<v-list-tile-sub-title v-for="(vItem, vIndex) in item.variants" :key="vIndex" v-if="vItem.qty">
						      		&#8377; {{$root.numberToLocale(item.rate)}} X {{vItem.qty}} {{vItem.unitName}}
						   		</v-list-tile-sub-title>

						      <!-- <v-list-tile-sub-title v-if="$root.TransactionSettings.mrpWiseStock">
						      	<span>MRP: <b>{{$root.numberToLocale(item.mrp)}}</b></span>
						      </v-list-tile-sub-title> -->
						    </v-list-tile-content>	

						    <v-list-tile-action style="padding-bottom:6px !important">&#8377; {{$root.numberToLocale(item.amount)}}</v-list-tile-action>
						</v-list-tile>

						<v-divider v-if="displayData.transactionProducts.length-1 != index"></v-divider>

						<template v-if="$root.TransactionSettings.enableBatch && item.transactionProductBatches && item.transactionProductBatches.length">
							<v-subheader class="mt-2 white-background">{{ item.selectedBatchType == 2 ? '#Series' : 'Batches#' }}</v-subheader>
							<v-divider></v-divider>
							<v-card flat v-for="(batch, batchIndex) in item.transactionProductBatches" :key="batchIndex">
								<v-card-text>
									<v-layout class="batch_layout" row wrap>
										<v-flex xs4 sm4 md4 mb-2 v-if="batch.batchNumber">
											<div light-opacity-color>Batch No.</div>
											<div>{{ batch.batchNumber }}</div>
										</v-flex>
										<v-flex xs4 sm4 md4 mb-2 v-if="batch.batchSize">
											<div light-opacity-color>Size</div>
											<div>{{ batch.batchSize }}</div>
										</v-flex>
										<v-flex xs4 sm4 md4 mb-2 v-if="batch.batchMRP">
											<div light-opacity-color>MRP</div>
											<div>{{ batch.batchMRP }}</div>
										</v-flex>
										<v-flex xs4 sm4 md4 mb-2 v-if="batch.mfgDate">
											<div light-opacity-color>Mfg. Date</div>
											<div v-if="batch.mfgDate">{{ batch.mfgDate | moment($root.batchDateFormat) }}</div>
										</v-flex>
										<v-flex xs4 sm4 md4 mb-2 v-if="batch.expDate">
											<div light-opacity-color>Exp. Date</div>
											<div v-if="batch.expDate">{{ batch.expDate | moment($root.batchDateFormat) }}</div>
										</v-flex>
										<v-flex xs4 sm4 md4 mb-2 v-if="batch.purchaseRate">
											<div light-opacity-color>Purchase Rate</div>
											<div>{{ batch.purchaseRate }}</div>
										</v-flex>
										<v-flex xs4 sm4 md4 mb-2 v-if="batch.field1">
											<div light-opacity-color>Serial Number</div>
											<div>{{ batch.field1 }}</div>
										</v-flex>
										<v-flex xs4 sm4 md4 mb-2 v-if="batch.field2">
											<div light-opacity-color>IMEI Number</div>
											<div>{{ batch.field2 }}</div>
										</v-flex>
										<v-flex xs4 sm4 md4 mb-2 v-if="batch.field3">
											<div light-opacity-color>Part Number</div>
											<div>{{ batch.field3 }}</div>
										</v-flex>
										<v-flex xs4 sm4 md4 mb-2 v-if="batch.field4">
											<div light-opacity-color>Model Number</div>
											<div>{{ batch.field4 }}</div>
										</v-flex>
										<v-flex xs4 sm4 md4 mb-2>
											<div light-opacity-color>Quantity</div>
											<div>{{ batch.qty }}</div>
										</v-flex>
									</v-layout>
								</v-card-text>
							</v-card>
							<v-divider v-if="batchIndex != item.transactionProductBatches.length - 1"></v-divider>
						</template>
						

					</div>
				</v-list>

			    <div v-if="displayData.notes" class="margin-top-ten">
					<v-list full-width nopadding>
					  	<v-list-tile>
				          	<v-list-tile-content>
				              	<v-list-tile-title medium-theme-color>Notes</v-list-tile-title>
				            </v-list-tile-content>
					    </v-list-tile>
					</v-list>

					<v-divider></v-divider>

					<v-card flat class="note-card">
					  	<v-card-text font16 v-html="displayData.notes" white-space-pre-line></v-card-text>
					</v-card>
				</div>

			</div>

			<dialog-confirmation ref="ref_dialogCancelDeleteTransaction" :header="confirmationDialogHeader" :confirmationMessage="confirmationMessage" :actionMethod="fn_callCancelTransaction" :params="{type:actionType}" :displayView='true' okBtnText="Yes" cancelBtnText="No" icon="warning" iconClass="redcolor" textClass="redcolor"></dialog-confirmation>
			
			<v-snackbar v-model="snackbar" :timeout="2000">{{snackbar_msg}}</v-snackbar>
		</div>

		<div id="printable" full-width>
			<print-template ref="ref_printTemplate" :data="printData" v-if="printData!=null"></print-template>
		</div>

		<!-- <dialog-permission ref="ref_dialogPermission"></dialog-permission> -->

		<v-snackbar v-model="snackbarOpenFile">
          File downloaded!
          <v-btn flat color="primary" @click.native="$root.fn_openDownloadedFile">Open</v-btn>
        </v-snackbar>
	</div>
</template>

<script>
const menuItem = require('../../../../config.js').configs.menuItem;
const transactionForms = require('../../../../config.js').configs.transactionForms;

import dialogConfirmation from '../../../dialogs/dialog_confirmation'

import printTemplate from '../../../invoice_templates/invoices/template201'

import {transactionMixin} from '../../transaction_mixin'

	export default{
		props:['settings'],
		mixins: [transactionMixin],
		data(){
			return{
				displayData:{},
				toolbarTitle:null,
				selectedNatureValue:null,
				snackbar:false,
				snackbar_msg:null,
				actionType:null,
				confirmationDialogHeader:null,
				confirmationMessage:null,
				printData:null
			}
		},
		components:{
			'dialog-confirmation': dialogConfirmation,
			'print-template': printTemplate
		},
		methods:{

			// fn_printData: function(){
			// 	this.fn_getPrintData();
			// 	AndroidRoutingTest.print();
			// },

			fn_goBack: function(){
				this.$router.go(-1);
			},

			fn_bindInvoiceTemplate: function(type){

				if(this.disableAction){
					return;
				}

				this.disableAction = true;

				let self = this;
				setTimeout(function(){
					self.disableAction = false;
				},500);

				if(type=='sharewhatsapp'){
					this.fn_shareInvoice('sharewhatsapp');
				}
				else if(type=='print'){
					this.fn_getPrintData('StockJournalPrintData', this.displayData.transactionId, 'print');
				}
				else if(type=='pdf'){
					this.fn_getPrintData('StockJournalPrintData', this.displayData.transactionId, 'pdf');
				}
				else if(type=='share'){
					this.fn_shareInvoice('share');
				}
			},

			fn_shareInvoice: function(type){
				let shareObj = {};
				shareObj.shareType = type=='sharewhatsapp' ? 'share' : 'ShareOther';
				// shareObj.shareType = this.displayData.primaryMobileNumber && type == 'sharewhatsapp' ? 'ShareOnWhatsApp' : 'Share';
				shareObj.subject = "Stock Journal Details";
				shareObj.textMessage = this.$tShare('share.stockAdjustmentMessage', {
					date: this.$moment(this.displayData.createdDate).format('DD-MMM-YYYY'),
					businessName: this.$root.CurrentBusiness.BusinessName
				});
				this.fn_getPrintData('StockJournalPrintData', this.displayData.transactionId, 'pdf', shareObj);
			},

			fn_callCancelTransaction: function(paramObj){
				this.$refs['ref_dialogCancelDeleteTransaction'].dialog_confimation = false;

				let self = this;
				if(paramObj.type=='cancel'){
					this.fn_cancelTransaction(this.displayData.transactionId, this.displayData.transactionListId);	
				}
				else{
					let transactionNumber = this.displayData.mergeTransactionNumber;
					this.fn_deleteTransaction(this.displayData.transactionId, this.displayData.transactionListId, function(status){
						if(status){
							// self.snackbar = true;
							// self.snackbar = '#'+transactionNumber+ ' deleted parmanently!.';
							self.showToast('Adjustment deleted parmanently')
							self.$router.go(-1);
						}
						else{
							// self.snackbar = true;
							// self.snackbar = 'Something went wrong. Try again!.';	
							self.showToast("Something went wrong. Try again");
						}
					});
				}
			},

			fn_comingSoon: function () {
				// this.snackbar_msg = "Coming Soon..";
				// this.snackbar = true;
				this.showToast("Coming Soon...");
			},

			fn_getData: function (type, itemId) {
				let filterObject = {};
				filterObject.type = this.settings.transactionTypeId;

				let self = this;
				this.getFilterData(type, itemId, filterObject, 
					{
						onSuccess: function(response){
							console.log(response);
							self.displayData = JSON.parse(response);
							self.displayData.transactionProducts.forEach(function (item) {
								item.transactionProductMode = item.variants[0].transactionProductMode;
								self.fn_getGroupTotal(item);
							})
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_getGroupTotal: function (tp) {
				let total = 0;
				tp.variants.forEach(function (item) {
					total += item.amount;
				});
				tp.amount = total;
			},

			fn_getBottomMenu: function (tagId) {

				var bottomMenu = {"BottomMenu": [menuItem.delete]};

				// this.displayData.status==0 ? bottomMenu = {"BottomMenu": [menuItem.share, menuItem.delete]} : '';

				this.setBottomMenu(tagId, bottomMenu, 
					{
						onSuccess: function (response) {
							console.log(response);
						},
						onError: function (error) {
							console.log(error);
						}
					}
				)
			},

			fn_menuItemClick: function(tagId, menuId, menuAction){
				// tagId id form future use
				// menuId id form future use
				if(menuAction=='edit' && this.displayData && this.displayData.transactionId){
					this.fn_edit();
				}
				else if(menuAction=='cancel'){
					// this.fn_cancelTransaction(this.displayData.transactionId, 'display');
					this.actionType = 'cancel';
					this.confirmationDialogHeader = "Cancel Transaction?";
					this.confirmationMessage = "Cancelled transaction cannot be uncancelled. Are you sure you want to cancel this transaction?"
					this.$refs['ref_dialogCancelDeleteTransaction'].dialog_confimation = true;
				}
				else if(menuAction=='delete'){
					this.actionType = 'delete';
					this.confirmationDialogHeader = "Delete Transaction?";
					this.confirmationMessage = "Deleted transaction cannot be restored. Are you sure you want to delete this transaction?"
					this.$refs['ref_dialogCancelDeleteTransaction'].dialog_confimation = true;
				}
				else if(menuAction=='share'){
					// this.fn_shareInvoice('share');
					this.fn_bindInvoiceTemplate('share');
				}
			},

			fn_edit: function () {
				this.$router.push({path:'/transactions/inventory/stockadjustment/items/'+this.displayData.transactionId+'/edit'});
			},

			fn_closeDialog: function(){
				this.$refs['ref_dialogPermission'].dialog_permission = false;
			},

			fn_showWebView: function () {
				var viewObject = {};

				var tagId = null;
				this.$route.params && this.$route.params.tagId ? tagId = this.$route.params.tagId : '';
				var self = this;

				this.showWebView(tagId, viewObject, 
					{
						onSuccess: function(response){
				          console.log(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }, 
				        // onChange: null, 
				        onMenuItemClick: function (tagId, menuId, menuAction, itemId) {
							self.fn_menuItemClick(tagId, menuId, menuAction, itemId)
						}
					}
				);
			},

			// fn_getPrintData: function(){
			// 	var self = this;
		 //  		this.getData('StockJournalPrintData', this.displayData.transactionId, 
			// 		{
			// 			onSuccess: function(response){
			// 	          	console.log(response);
			// 	          	self.printData = JSON.parse(response);
			// 	          	setTimeout(function(){
			// 	          		self.$refs['ref_printTemplate'].fn_init();
			// 	          	},300);
			// 	        }, 
			// 	        onError: function(error){
			// 	        	console.log(error);
			// 	        }
			// 		}
		 //        );
			// },
		},
		mounted: function(){

			window.js_globals.fn_getBottomMenu = this.fn_getBottomMenu;
			window.js_globals.fn_onBackPress = this.fn_goBack;

			this.fn_showWebView();
	        
			if(this.$route.params && this.$route.params.tagId){
				this.fn_getData('TransactionProducts', this.$route.params.tagId);
			}
		},
		beforeRouteLeave (to, from, next) {
			if(this.$refs['ref_dialogCancelDeleteTransaction'].dialog_confimation){
				this.$refs['ref_dialogCancelDeleteTransaction'].dialog_confimation = false;
				// this.$refs['ref_dialogPermission'].dialog_permission = false;
				next(false);
			}
			else{
				next(true);	
			}
	    }
		// computed:{
		// 	transactionNumber: function () {
		// 		let prefix = this.displayData.prefix ? this.displayData.prefix + '/' : '';
	 //    		let suffix = this.displayData.suffix ? '/' + this.displayData.suffix : '';
	 //    		let transactionNumber = this.displayData.transactionNumber ? this.displayData.transactionNumber : '';
	 //    		return prefix + transactionNumber + suffix;
		// 	}
		// }
	}

</script>


// WEBPACK FOOTER //
// src/components/transactions/forms/stock_adjustment/display.vue